import { Rows3, Rows4 } from "lucide-react";
import { Segmented } from "@/components/ui/controls";
import { useT } from "@/lib/i18n";
import { prefs, usePrefs, type Density } from "@/lib/prefs";

/**
 * Comfortable / compact, for lists and the inbox. The choice is per device (prefs → `<html data-density>`), so every
 * list follows it. Style rows with the density tokens (`py-[var(--row-pad-y)]`, `p-[var(--card-pad)]`,
 * `h-[var(--control-h)]`) instead of reading the value.
 */
export function DensityToggle({ size = "sm", className }: { size?: "sm" | "md"; className?: string }) {
  const { t } = useT();
  const { density } = usePrefs();
  return (
    <Segmented<Density>
      size={size}
      className={className}
      label={t("kit.density.label")}
      value={density}
      onChange={(v) => prefs.setDensity(v)}
      options={[
        { value: "comfortable", label: <span className="sr-only sm:not-sr-only">{t("kit.density.comfortable")}</span>, icon: <Rows3 aria-hidden />, title: t("kit.density.comfortable") },
        { value: "compact", label: <span className="sr-only sm:not-sr-only">{t("kit.density.compact")}</span>, icon: <Rows4 aria-hidden />, title: t("kit.density.compact") },
      ]}
    />
  );
}

export function useDensity(): Density {
  return usePrefs().density;
}
